import React from "react";
import { SizeButton } from "../../../components/SizeButton";
import { StyleSize, StyleSizeSubscription } from "../../../../common/interfaces";
import { useDesignations } from "../../context/DesignationProvider";
import "./size-row.scss";
import { SizeSelectFieldSize } from "../../../types";

export type SizeRowProps = {
  sizes: StyleSize[] | StyleSizeSubscription[];
  isLoading?: boolean;
};

export const SizeRow: React.FC<SizeRowProps> = ({ sizes, isLoading = false }) => {
  const { productCode, setProductCode, setSize } = useDesignations();

  // Not the best place for this but it really works well
  // If the picked size is not a part of the row, deselect it
  // Otherwise, we could just clear the selected size on designation change in the context
  const selectedSize = sizes.find(({ productCode: productCodeFromSizes }) => productCodeFromSizes === productCode);

  const disabledProductCodes = sizes
    .filter((size) => (size as StyleSizeSubscription)?.available === false)
    .map((size) => size.productCode);

  if (!selectedSize || disabledProductCodes.includes(selectedSize.productCode)) {
    setProductCode(undefined);
  }

  const getLabel = (size: string) => {
    if (size.toLowerCase() === "onesize") {
      return "One Size";
    }
    return size;
  };

  const handleSelectSize = (size: SizeSelectFieldSize) => {
    setProductCode(size.sizeId);
    setSize(size.label);
  };

  return (
    <div className="c-size-row">
      {isLoading ? (
        <div>Checking availability...</div>
      ) : (
        sizes.map((size) => (
          <SizeButton
            key={size.productCode}
            size={{ sizeId: size.productCode, label: getLabel(size.size) }}
            isSelected={size.productCode === productCode}
            isDisabled={disabledProductCodes.includes(size.productCode)}
            onSelectSize={handleSelectSize}
            onDeselectSize={() => {
              /* Deselects automatically when a different size is picked */
            }}
          />
        ))
      )}
    </div>
  );
};
